import useTranslation from 'next-translate/useTranslation'
import { FC, useEffect, useState } from 'react'
import { FlexboxGrid, Loader } from 'rsuite'
import { useRouter } from 'next/router'

import VisaIcon from '../Icons/PaymentIcons/VisaIcon'
import MastercardIcon from '../Icons/PaymentIcons/MastercardIcon'
import AmexIcon from '../Icons/PaymentIcons/AmexIcon'
import DinersIcon from '../Icons/PaymentIcons/DinersIcon'
import CartesBancairesIcon from '../Icons/PaymentIcons/CartesBancairesIcon'
import SepaIcon from '../Icons/PaymentIcons/SepaIcon'
import PaypalIcon from '../Icons/PaymentIcons/PaypalIcon'
import ApplePayIcon from '../Icons/PaymentIcons/ApplePayIcon'
import GooglePayIcon from '../Icons/PaymentIcons/GooglePayIcon'
import RemoteCommerceIcon from '../Icons/PaymentIcons/RemoteCommerceIcon'
import MobilepayIcon from '../Icons/PaymentIcons/MobilepayIcon'
import RevolutPayIcon from '../Icons/PaymentIcons/RevolutPayIcon'
import AfterPayIcon from '../Icons/PaymentIcons/AfterPayIcon'
import KlarnaIcon from '../Icons/PaymentIcons/KlarnaIcon'
import LinkIcon from '../Icons/PaymentIcons/LinkIcon'
import InvoiceIcon from '../Icons/PaymentIcons/InvoiceIcon'
import fetcher from '../../utils/fetcher'
import { getCountryAndLocaleStrings } from '../../utils/locales'
import { isBusinessCustomer } from '../../lib/user'
import { StripePaymentMethodType } from '../../utils/stripe/types'

import styles from '../../styles/PaymentIconsSection.module.less'

// Map Stripe payment method types to appropriate icons
const paymentIconsMap: Record<StripePaymentMethodType, JSX.Element[]> = {
  card: [<VisaIcon key="visa" />, <MastercardIcon key="mastercard" />, <AmexIcon key="amex" />, <DinersIcon key="diners" />],
  cartes_bancaires: [<CartesBancairesIcon key="cartes_bancaires" />],
  sepa_debit: [<SepaIcon key="sepa" />],
  paypal: [<PaypalIcon key="paypal" />],
  apple_pay: [<ApplePayIcon key="apple_pay" />],
  google_pay: [<GooglePayIcon key="google_pay" />],
  link: [<LinkIcon key="link" />],
  remote_commerce: [<RemoteCommerceIcon key="remote_commerce" />],
  mobilepay: [<MobilepayIcon key="mobilepay" />],
  revolut_pay: [<RevolutPayIcon key="revolut_pay" />],
  afterpay: [<AfterPayIcon key="afterpay" />],
  klarna: [<KlarnaIcon key="klarna" />],
}

const PaymentIconsSection: FC = () => {
  const { t } = useTranslation('cart')
  const { locale: countryAndLocale } = useRouter()
  const { country } = getCountryAndLocaleStrings(countryAndLocale)

  const [paymentMethods, setPaymentMethods] = useState([])

  useEffect(() => {
    const getPaymentMethods = async () => {
      const res = await fetcher(`/api/v1/stripe/payment-methods?country=${country}`)
      const resJson = await res.json()
      setPaymentMethods(resJson.paymentMethods || [])
    }

    getPaymentMethods()
  }, [country])

  return (
    <div className="margin-top-spacer">
      <FlexboxGrid className={styles['icons-section']}>
        {paymentMethods.length > 0 ? paymentMethods
          ?.map((method) => paymentIconsMap[method] || [])
          .map((icon) => (
            icon
          )) : <Loader />}
        {paymentMethods?.length > 0 && isBusinessCustomer() && <InvoiceIcon text={t('Invoice')} />}
      </FlexboxGrid>
    </div>
  )
}

export default PaymentIconsSection
